import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod/v4";

const inventoryItemSchema_ = z.object({
  productId: z.string(),
  productName: z.string(),
  sku: z.string().nullable(),
  priceCents: z.number().nullable(),
  locationId: z.string(),
  locationName: z.string(),
  onHand: z.number(),
  committed: z.number(),
  available: z.number(),
});
export const inventoryItemSchema: z.ZodType<InventoryItem> =
  inventoryItemSchema_;
export interface InventoryItem extends z.infer<typeof inventoryItemSchema_> {}

export const getInventoryItems = unaryRpc({
  name: "getInventoryItems" as const,
  input: z.object({
    returnsCenterId: z.string().optional(),
    search: z.string().optional(),
    page: z.number().min(0).optional(),
    pageSize: z.number().min(1).max(500).default(50),
  }),
  output: z.object({
    items: z.array(inventoryItemSchema),
    totalCount: z.number(),
    page: z.number(),
    pageSize: z.number(),
  }),
});

export type InventoryItemsOutput = z.infer<
  (typeof getInventoryItems)["output"]
>;
